import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";

const WorkFlow = [
  {
    logo: GenerativeAIServiceTick,
    title: "Ionic Native",
    description:
      "Our proficiency in Ionic Native enables us to seamlessly integrate a wide range of device-specific features into your applications.",
    count: "01",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Ionic Storage",
    description:
      "We provide robust solutions for data management across platforms with Ionic Storage.",
    count: "02",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Ionic Auth",
    description:
      "This is our go-to-optimum solution for secure user authentication and management.",
    count: "03",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Ionic Analytics",
    description:
      "Our extensive use of Ionic Analytics allows us to make well-informed decisions about Ionic App Development.",
    count: "04",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Ionic Push",
    description:
      "This is one capability that enables you to maintain effective communication with your users.",
    count: "05",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Ionic Capacitor",
    description:
      "The Ionic Capacitor is essential for our Ionic App Development Services as it allows us for seamless integration of web technologies with the native capabilities of the device.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 nlp_process_flow search-engine-workflow">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              TekRevol’s Core Competencies in <span>Ionic App Development</span>{" "}
              Services
            </h2>
            <p>
              At TekRevol, our core competencies in developing Ionic Apps
              usually involve a thorough understanding of different industries
              and cutting-edge technologies.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-3 mb-md-4">
              <div
                className="workflow_items"
                style={{ background: "#F8F8FB", pointerEvents: "none" }}
              >
                <div className="item_name">
                  <span style={{ color: "#314252" }}>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
